export const GET_PERFORMANCE_REVIEWS_REQUEST = "GET_PERFORMANCE_REVIEWS_REQUEST"
export const GET_PERFORMANCE_REVIEWS_SUCCESS = "GET_PERFORMANCE_REVIEWS_SUCCESS"
export const GET_PERFORMANCE_REVIEWS_FAILURE = "GET_PERFORMANCE_REVIEWS_FAILURE"
export const GET_NEXT_PAGE_PERFORMANCE_REVIEWS_REQUEST = "GET_NEXT_PAGE_PERFORMANCE_REVIEWS_REQUEST"
